import React, { useState } from 'react';
import '../assets/styles/components/Product.sass';

const ID_TYPE_JERSEY = '6';

const Product = (props) => {
  const { id, foto1, foto2, foto3, foto4, name, promotion, price, description, size, handleSubmit, talla_id, handleOpenModal } = props;
  const URL = 'https://legendofeldorado.com/series-admin-temporal/img/productos';
  const pictures = [foto1, foto2, foto3, foto4];
  const [image, setImage ] = useState(foto1);
  const [number, setNumber ] = useState(1);
  const [addProduct, setAddProduct ] = useState({
    'nameClass': 'addToCart',
    'text': 'Agregar al carro'
  });

  const handleClick = (name) => {
    setImage(name);
  }

  const handleDel = () => {
    if (number > 1) {
      setNumber(number - 1);
    }
  }

  const handleAdd = () => {
    setNumber(number + 1);
  }

  const handleAddProduct = () => {
    setAddProduct({
      'nameClass': 'addingToCart',
      'text': 'Agregado al carro'
    })
    setTimeout(() => resetAddProduct(), 2000);
  }

  const resetAddProduct = () => {
    return setAddProduct({
      'nameClass': 'addToCart',
      'text': 'Agregar al carro'
    });
  }

  const currency = (value) => {
    let thousands = "."
    let i = parseInt(value = Math.abs(Number(value) || 0)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;
    return (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);
  }

  return (
    <div className="row Product">
      <form onSubmit={event => handleSubmit(event)}>

        <div className="col-12">
          <h3 className="mb-2">{name}</h3>
          {promotion ? (
            <div className="Product-price">
              <span className="Product-price-title --caldas">PREVENTA</span>
              <span className="mr-2">
                ${currency(promotion)}
              </span>
              <span className="Product-price-promotion">
                ${currency(price)}
              </span>
              <input type="hidden" name="price" value={promotion} />
            </div>
          ) : (
            <>
              <span className="Product-blue">ORDEN</span>
              <span>
                ${currency(price)}
              </span>
              <input type="hidden" name="price" value={price} />
            </>
          )}
        </div>

        <div className="col-12 mb-2">
          <div className="Product-img-lateral">
            {pictures.map(item => {
              return item &&
                <button type="button" onClick={() => handleClick(item)}>
                  <img
                    className="img-fluid"
                    src={`${URL}/${item}`}
                    alt="La Leyenda" />
                </button>
            })}
          </div>
          <div className="Product-img-principal">
            <img className="img-fluid" src={`${URL}/${image}`} alt="La Leyenda" />
          </div>
        </div>
        
        <div className="col-12">
          <div className="row">
            <div className="form-group col-7">
              <label htmlFor="talla">Talla</label>
              <select className="form-control" id="talla" name="talla">
                {size.specifications.map((item, index) => (
                  <option key={`index-${index}`} value={item.name}>{item.name}</option>
                ))}
              </select>
            </div>
            
            <div className="form-group col-5">
              <label htmlFor="cantidad">Cantidad</label>
              <div className="input-group">
                <div className="input-group-prepend">
                  <button className="btn btn-outline-secondary button-del" type="button" onClick={() => handleDel()}>-</button>
                </div>
                <input type="text" className="form-control text-center" name="cantidad" value={number} autoComplete="off" />
                <div className="input-group-append">
                  <button className="btn btn-outline-secondary button-add" type="button" onClick={() => handleAdd()}>+</button>
                </div>
              </div>
            </div>

            <div className="col-12">
              <input type="hidden" name="id" value={id} />
              <input type="hidden" name="item" value={name} />
                <button className={`btn Product-${addProduct.nameClass} --caldas`} type="submit" onClick={() => handleAddProduct()}>{addProduct.text}</button>
            </div>
          </div>
        </div>
      </form>

      <div className="col-12 Product-description">
        <h4>DESCRIPCIÓN</h4>
        <p>{description}</p>
        {talla_id === ID_TYPE_JERSEY &&
          <button type="button" className="btn btn-ll --caldas mc-b2" onClick={() => handleOpenModal()}>Guía de Tallas kafitt</button>
        }
      </div>
    </div>
  )
}

export default Product;
